import { Injectable } from '@angular/core'
import { CoreSettingsService, CoreSettingsType, LoggerLevels } from 'core'
import { environment } from '../../../environments/environment.staging'

@Injectable()
export class LocalCoreSettingsService extends CoreSettingsService {
  get settings() {
    const settings: Omit<CoreSettingsType, 'artistAdministrationLink' | 'bmstvUrl'> = {
      production: false,
      environment: 'staging',
      baseUrl: environment.baseUrl,
      beatmakerApiBaseUrl: environment.beatmakerApiBaseUrl,
      appLoggerLevel: LoggerLevels.debug,
      urls: {
        prodspageServiceAPI: 'https://prods-page-api.testbtv.ru',
        saveColorsUrl: `${environment.baseUrl}/ProdsPage/Management/UpdateColors`,
        resetColors: `${environment.baseUrl}/ProdsPage/Management/ResetColors`,
        paymentDomainUrl: environment.baseUrl,
        commonDomainUrl: environment.baseUrl,
        settingsUrl: environment.baseUrl,
        currentApp: 'https://XXX.herokuapp.com',
        assetsURL: '.'
      },
      routingUrl: {
        beatmakerPage: null,
        beatPage: '/tracks/{{beatId}}',
        freeBeatPage: null,
        artistPage: null,
        songPage: null,
        checkoutPage: '/checkout'
      }
    }
    return settings
  }
}
